<template>
	<div class="dialogBox" >
		<el-dialog :title="title" :visible.sync="innerVisible" width="710px" center @closed="innerVisible = false">
			<el-form>
				<el-form-item>
					<el-button type="primary" icon="el-icon-plus" class="mr10" @click="handleAdd">{{$t('Add')}}</el-button>
				</el-form-item>
				
			</el-form>
			<el-table :data="table_data" border max-height="920px" class="table" :cell-style="{ padding: '0' }">
				<el-table-column align="center" prop="a" label="盈利" width="140"></el-table-column>
				<el-table-column align="center" prop="o" :label="$t('ReductionCompensation')" width="140"></el-table-column>
				<el-table-column align="center" prop="r" label="连赢加速系数" width="140"></el-table-column>
				<el-table-column  :label="$t('Actions')">
					<template slot-scope="scope">
						<el-button type="text" icon="el-icon-edit" @click="handleModifyItem(scope.$index, 1)">{{$t('Edit')}}</el-button>
						<el-button type="text" icon="el-icon-edit" @click="handleModifyItem(scope.$index, 2)">{{$t('Delete')}}</el-button>
					</template>
				</el-table-column>
			</el-table>
			<span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="handleCommit()">{{$t('Save')}}</el-button>
			</span>
		</el-dialog>
		<el-dialog class="inputPop" :title="title" :visible.sync="adddialog" width="380px" center>
			<el-form :inline="true">
				<el-form-item label="盈利:">
					<el-input type="number" v-model="modifyData.a" :placeholder="$t('PleaseEnter')" @blur="checkInput1"></el-input>
				</el-form-item>
			</el-form>
			<el-form :inline="true">
				<el-form-item label="降赔:">
					<el-input type="number" v-model="modifyData.o" :placeholder="$t('PleaseEnter')" @blur="checkInput2"></el-input>
				</el-form-item>
			</el-form>
			<el-form :inline="true">
				<el-form-item label="连赢加速系数:">
					<el-input type="number" v-model="modifyData.r" :placeholder="$t('PleaseEnter')" @blur="checkInput3"></el-input>
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="handleCommitItem()">{{$t('Confirm')}}</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
import { app } from '@/api/app.js'
import base from '@/api/base.js'
export default {
	extends: base,
	props: {
		show: {
			type: Boolean,
			default: false,
		},
		dialogData: {
			type: Object,
			default: () => {},
		},
	},
	data() {
		return {
			title: '设置盈利降赔',
			loading: false,
			currIndex: null,
			adddialog: false,
			modifyData: {
				a: null,
				o: null,
				r: null,
			}
		}
	},
	computed: {
		innerVisible: {
			get: function () {
				return this.show
			},
			set: function (val) {
				this.table_data = []
				this.$emit('update:show', val)
			},
		},
	},
	watch: {
		dialogData(newData, oldData) {
			this.initData();
		}
	},
	created() {
		this.app = app
	},
	methods: {
		initData() {
			if(this.dialogData.data.ConfigValue){
				this.table_data = JSON.parse(this.dialogData.data.ConfigValue);
				this.tableSort()
			}else {
				this.table_data = [];
			}
			
		},
		handleAdd() {
			this.adddialog = true
			this.modifyData = {
				a: null,
				o: null,
				r: null,
			}
		},
		handleModifyItem(index, type) {
			if(type == 1) {
				this.currIndex = index
				this.adddialog = true
				this.modifyData = this.table_data[index]
			}else if(type == 2) {
				this.table_data.splice(index, 1)
				this.currIndex = null
			}
		},
		handleCommit() {
			this.dialogData.data.ConfigValue = JSON.stringify(this.table_data)
			app.getGoogleCode((GoogleCode) => {
				this.dialogData.data.GoogleCode = GoogleCode
				
				app.post('/admin/config/modify', this.dialogData.data, (result) => {
					this.innerVisible = false
					this.$message.success('提交成功')
					this.$emit('updataInfo')
				})
				
			})
		},
		handleCommitItem() {
			for (let var1 in this.modifyData) {
				this.modifyData[var1] = Number(this.modifyData[var1])
			}
			for (var i = 0; i < this.table_data.length; i++) {
				var value = this.table_data[i]
				if(i != this.currIndex && value.a == this.modifyData.a){
					this.$message.error('盈利值已经存在，请重新输入')
					return;
				}
			}
			this.adddialog = false
			if(this.currIndex == null){
				this.table_data.push(this.modifyData)
			}else {
				this.table_data[this.currIndex] = this.modifyData
				this.currIndex = null
			}
			this.tableSort()
		},
		checkInput1(value) {
			if(Number(value) < 0){
				this.modifyData.a = 0
			}
		},
		checkInput2(value) {
			if(Number(value) < 0){
				this.modifyData.o = 0
			}
		},
		checkInput3(value) {
			if(Number(value) < 0){
				this.modifyData.r = 0
			}
		},
		tableSort() {
			this.table_data.sort((a,b) => a.a - b.a)
		}
	},
}
</script>

<style scoped>
.inputPop ::v-deep .el-form-item__label {
	width: 100px;
	text-align: right;
}
</style>
